<template>
  <div id="page-work-detail">
    <el-form
      class="search-form"
      ref="searchForm"
      label-width="6em"
      :inline="true"
      :model="searchForm"
    >
      <el-row>
        <el-form-item label="日期" required>
          <filter-date-range
            :value.sync="dateRange"
            :range="30"
            :init-range="1"
            :startDate="startDate"
            required
          />
        </el-form-item>
        <el-form-item v-if="workDetail.isShowSupplierFilter" label="合作商" required>
          <filter-businessline-partner
            required
            :value.sync="searchForm.supplierId"
            :code.sync="supplierCode"
            :businessLine="businessLine"
          />
        </el-form-item>
        <el-form-item label="城市">
          <filter-businessline-region
            :value.sync="searchForm.regionId"
            :businessLine="businessLine"
          />
        </el-form-item>
        <el-form-item :label="workDetail.filterPartnerStaffLabel" label-width="8em">
          <el-input placeholder="非必填" v-model="searchForm.name" clearable />
        </el-form-item>
        <el-form-item style="float: right">
          <el-button type="primary" @click="handleQuery(true)">查询</el-button>
          <el-button @click="exportData" :loading="exportLoading" :disabled="isDisableExport"
            >导出</el-button
          >
        </el-form-item>
      </el-row>
    </el-form>
    <section class="data-container">
      <common-report-table
        ref="table"
        url="getGenericData"
        tableAlign="center"
        :type="2"
        :showHeaderTip="workDetail.showHeaderTip"
        :export.sync="isDisableExport"
        :filterParams="filterParams"
      />
    </section>
  </div>
</template>

<script>
import { dateFormat } from '@/utils'
import { WORK_DETAIL } from './config'
import exportData from '@/mixins/exportData'
import lxUtils from '@/mixins/lx'
const dayRange = 24 * 60 * 60 * 1000

export default {
  mixins: [exportData, lxUtils],
  data() {
    return {
      businessLine: 2,
      cid: '',
      isDisableExport: true,
      startDate: Date.now() - dayRange,
      dateRange: [],
      workDetail: {},
      supplierCode: this.$route.query.supplierCode,
      searchForm: {
        ...this.$route.query,
        name: '',
      },
      // 导出参数
      exportFileName: '',
      exportUrl: 'exportReportData',
    }
  },
  computed: {
    filterParams() {
      const [date, endDate] = this.dateRange
      const { regionId, name } = this.searchForm
      return {
        pageId: this.workDetail.pageId,
        date: dateFormat(date, 'yyyy-MM-dd'),
        endDate: dateFormat(endDate, 'yyyy-MM-dd'),
        supplierCodeList: this.supplierCode ? [this.supplierCode] : [],
        regionIdList: regionId ? [regionId] : [],
        name: name ? [name] : [],
      }
    },
    exportParams() {
      return {
        ...this.filterParams,
        supplierCodeList: this.filterParams.supplierCodeList.join(','),
        regionIdList: this.filterParams.regionIdList.join(','),
        name: this.filterParams.name.join(','),
      }
    },
  },
  watch: {
    '$route.path': {
      handler(val) {
        const index = val.lastIndexOf('/')
        const type = val.substring(index + 1, val.length)
        if (WORK_DETAIL[type]) {
          this.workDetail = WORK_DETAIL[type]
          this.cid = this.workDetail.cid
          this.exportFileName = this.workDetail.exportFileName
          setTimeout(() => {
            this.handleQuery(true)
          }, 1000)
        }
      },
      immediate: true,
    },
  },
  mounted() {
    this.init()
  },
  methods: {
    init() {
      const { date, endDate } = this.$route.query
      if (date) {
        this.dateRange = [date, endDate || date]
      }
    },
    handleQuery(init = false) {
      if (this.workDetail.isShowSupplierFilter && !this.searchForm.supplierId) {
        this.$message.error('合作商不能为空')
        return
      }
      this.$refs.table && this.$refs.table.fetchData(init, this.filterParams)
    },
  },
}
</script>

<style></style>
